"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledElement = exports.StyledDeleteIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formatSize = _interopRequireDefault(require("../../../../utils/formatSize"));
var _symbols = require("../../../../constants/symbols");
var _iconsReact = require("../../../../icons-react");
var _editor = require("../../../../icons-react/editor");
var AttachmentList2 = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var list = _ref.list,
    _ref$onDelete = _ref.onDelete,
    onDelete = _ref$onDelete === void 0 ? null : _ref$onDelete,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: className
  }, list.map(function (_ref2) {
    var name = _ref2.name,
      progress = _ref2.progress,
      size = _ref2.size,
      url = _ref2.url,
      lastModified = _ref2.lastModified;
    return /*#__PURE__*/_react["default"].createElement(StyledElement, {
      $url: url,
      key: "".concat(lastModified, "-").concat(name)
    }, /*#__PURE__*/_react["default"].createElement(StyledProgressBar, {
      $progress: progress
    }), /*#__PURE__*/_react["default"].createElement(StyledContent, {
      $progress: progress
    }, typeof progress !== 'number' && /*#__PURE__*/_react["default"].createElement(StyledAttachmentIcon, null), url ? /*#__PURE__*/_react["default"].createElement(StyledLink, {
      href: url,
      target: "_blank"
    }, name || 'Вложение') : /*#__PURE__*/_react["default"].createElement(StyledName, null, name), !!size && /*#__PURE__*/_react["default"].createElement(StyledSize, null, (0, _formatSize["default"])(size)), onDelete && /*#__PURE__*/_react["default"].createElement(StyledDeleteIcon, {
      onClick: function onClick() {
        return onDelete(lastModified);
      }
    })));
  }));
});
AttachmentList2.displayName = 'AttachmentList2';
var StyledElement = exports.StyledElement = _styledComponents["default"].li.withConfig({
  displayName: "AttachmentList2__StyledElement",
  componentId: "sc-3054hd-0"
})(["position:relative;align-items:center;color:", ";display:flex;font-size:12px;line-height:19px;& + &{margin-top:2px;}"], function (_ref3) {
  var $url = _ref3.$url;
  return $url ? '#007aff' : '#4d4d4d';
});
var StyledProgressBar = _styledComponents["default"].div.withConfig({
  displayName: "AttachmentList2__StyledProgressBar",
  componentId: "sc-3054hd-1"
})(["display:flex;position:absolute;border-radius:13px;height:100%;width:", ";background-color:#dcedff;"], function (_ref4) {
  var $progress = _ref4.$progress;
  return $progress ? "".concat(Math.min(Number($progress), 100), "%") : '0%';
});
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "AttachmentList2__StyledContent",
  componentId: "sc-3054hd-2"
})(["z-index:1;display:flex;width:100%;align-items:center;padding:", ";"], function (_ref5) {
  var $progress = _ref5.$progress;
  return typeof $progress === 'number' ? '5px 10px' : '';
});
var StyledAttachmentIcon = (0, _styledComponents["default"])(_editor.Attachment).withConfig({
  displayName: "AttachmentList2__StyledAttachmentIcon",
  componentId: "sc-3054hd-3"
})(["width:18px;height:16px;min-width:17px;min-height:16px;margin-right:4px;path{stroke:#007aff;}"]);
var StyledDeleteIcon = exports.StyledDeleteIcon = (0, _styledComponents["default"])(_iconsReact.Close).withConfig({
  displayName: "AttachmentList2__StyledDeleteIcon",
  componentId: "sc-3054hd-4"
})(["cursor:pointer;stroke:#4d4d4d;width:10px;height:10px;margin-left:auto;"]);
var StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "AttachmentList2__StyledLink",
  componentId: "sc-3054hd-5"
})(["color:", ";line-height:1.36;font-size:inherit;text-decoration:none;:hover{text-decoration:underline;}"], function (_ref6) {
  var href = _ref6.href;
  return href ? '#007aff' : '#4d4d4d';
});
var StyledName = _styledComponents["default"].span.withConfig({
  displayName: "AttachmentList2__StyledName",
  componentId: "sc-3054hd-6"
})(["color:inherit;font-size:inherit;max-width:80%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
var StyledSize = _styledComponents["default"].span.withConfig({
  displayName: "AttachmentList2__StyledSize",
  componentId: "sc-3054hd-7"
})(["font-size:inherit;white-space:nowrap;margin-left:3px;margin-right:5px;:before{content:'", "';margin-right:3px;}"], _symbols.DOT_OPERATOR);
var _default = exports["default"] = AttachmentList2;